export default __webpack_public_path__ + "static/media/explainer_love_content@2x.6254d9b7.png";